import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-41f576b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "report-creation" }
const _hoisted_2 = { class: "report-creation__content" }
const _hoisted_3 = { class: "report-creation__content-item" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "report-creation__title" }, "Пациент", -1))
const _hoisted_5 = { class: "report-creation__content-item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "report-creation__title" }, "Наличие зубного камня", -1))
const _hoisted_7 = { class: "report-creation__content-item" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Наличие пигментированного зубного налета ")
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "report-creation__title" }, "Дата приёма", -1))
const _hoisted_10 = { class: "report-creation__footer" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Создать отчёт ")

import { ref } from 'vue'
import { useRouter } from 'vue-router'
import ImagesUploader from '@/widgets/WReportCreation/components/ImagesUploader.vue'
import TeethStone from '@/widgets/WReportCreation/components/TeethStone.vue'
import { ReportCreationResponseType } from '@/widgets/WReportCreation/types/reportCreation.types'
import {
  REPORT_CREATION_MODE,
  REPORT_PAGE_NAME,
} from '@/widgets/WReportCreation/constants/reportCreation'
import {
  checkImagesFiles,
  checkTeethStone,
  createNullReport,
  createPatientAndReport,
  createReport,
} from '@/widgets/WReportCreation/api/create.api'
import { useReportCreation } from '@/widgets/WReportCreation/composables/useReportCreation'
import { showErrorMessage } from '@/shared/utils'
import { reportApi, userApi } from '@/shared/api'
import { useUser } from '@/shared/composables'
import ChoiceCreationMode from '@/widgets/WReportCreation/components/ChoiceCreationMode.vue'
import { ElMessage } from 'element-plus'
import { ECariesFillingExtracted } from '@/entities/ECariesFillingExtracted'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const { setUser } = useUser()
const {
  patientCreationForm,
  isPigmentedPlaque,
  receiptDate,
  reportCreationMode,
  resetData,
} = useReportCreation()

const loading = ref(false)

const openPlaqueReportPage = async (
  newReportInfo: ReportCreationResponseType
) => {
  const isOldReport = await checkIfReportIsOld(newReportInfo.reportId)

  await updateInfoAboutCurrentOrganization()

  resetData()

  router.push({
    name: isOldReport ? REPORT_PAGE_NAME.oldReport : REPORT_PAGE_NAME.newReport,
    params: {
      patientId: newReportInfo.patientId,
      reportId: newReportInfo.reportId,
    },
  })
}

const checkIfReportIsOld = async (reportId: number): Promise<boolean> => {
  const [error, response] = await reportApi.getReport(reportId)

  if (error) {
    showErrorMessage(error)

    return false
  }

  return response.data.is_old
}

const updateInfoAboutCurrentOrganization = async (): Promise<void> => {
  const [_, response] = await userApi.getInfoAboutMe()
  setUser(response.data)
}

const handleCreateReport = async (): Promise<void> => {
  let reportCreationResponse: ReportCreationResponseType
  if (!checkImagesFiles()) {
    ElMessage({
      message: 'Выберите фотографии',
      type: 'error',
    })
    return
  }
  if (!checkTeethStone()) {
    ElMessage({
      message: 'Заполните поле зубного камня',
      type: 'error',
    })
    return
  }
  loading.value = true

  if (reportCreationMode.value === REPORT_CREATION_MODE.nullPatient) {
    reportCreationResponse = await createNullReport()
  }

  if (reportCreationMode.value === REPORT_CREATION_MODE.patientExists) {
    reportCreationResponse = await createReport()
  }

  if (reportCreationResponse) {
    await openPlaqueReportPage(reportCreationResponse)
    loading.value = false
  }

  if (reportCreationMode.value === REPORT_CREATION_MODE.newPatient) {
    if (patientCreationForm.value) {
      patientCreationForm.value.validate(async (valid): Promise<boolean> => {
        if (!valid) return false

        reportCreationResponse = await createPatientAndReport()

        if (reportCreationResponse) {
          await openPlaqueReportPage(reportCreationResponse)
          loading.value = false
        }

        return !!reportCreationResponse
      })
    } else {
      loading.value = false
    }
  } else {
    loading.value = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(ChoiceCreationMode)
      ]),
      _createVNode(ImagesUploader, { class: "report-creation__content-item" }),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(TeethStone)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_el_checkbox, {
          modelValue: _unref(isPigmentedPlaque),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(isPigmentedPlaque) ? (isPigmentedPlaque).value = $event : null)),
          label: 1,
          class: "report-creation__pigment"
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createVNode(_unref(ECariesFillingExtracted), {
        isCreating: true,
        class: "report-creation__content-item"
      }),
      _hoisted_9,
      _createVNode(_component_el_input, {
        ref: "date",
        modelValue: _unref(receiptDate),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(receiptDate) ? (receiptDate).value = $event : null)),
        class: "report-creation__receipt",
        type: "date"
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_el_button, {
        loading: loading.value,
        class: "report-creation__footer-button",
        round: "",
        type: "primary",
        onClick: handleCreateReport
      }, {
        default: _withCtx(() => [
          _hoisted_11
        ]),
        _: 1
      }, 8, ["loading"])
    ])
  ]))
}
}

})